import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import WorkflowEditorView from '@/workflow/WorkflowEditorView.vue'

export const WORKFLOW_EDITOR = {
    componentName: 'WorkflowEditor',
    component: WorkflowEditorView,
    meta: {requiresOrg: true}
}

const {registerNavigationCommand} = useContaCommand()

const icon = 'i-ph-flow-arrow-fill'
const label = 'Workflow Editor'
const hotkey = 'w'
const route = WORKFLOW_EDITOR

registerNavigationCommand({
    route,
    label,
    icon,
    hotkey
})

registerRoute(route)
